
const IdentityManage = () => import('@/pages/authority/IdentityManage');
const AdministratorList = () => import('@/pages/authority/AdministratorList');

export default [
  {
    path: '/admin-list',
    component: AdministratorList,
    meta: [
      {
        name: '权限管理',
        url: ' ',
      },
      {
        name: '管理员列表',
        url: ' ',
      },
    ]
  },
  {
    path: '/role-manage',
    component: IdentityManage,
    meta: [
      {
        name: '权限管理',
        url: ' ',
      },
      {
        name: '身份管理',
        url: ' ',
      },
    ],
  },
];
